<div class="popup-content" [attr.id]="data.equipment">
  <div class="header">
    <h4 class="header-name">{{ data.assetType?.name }}</h4>
    <button class="popup-close-button" (click)="closePopup()">
      <img class="x-icon popup-close" alt="close-icon" src="../../../../assets/icons/close-icon-gray.svg" />
    </button>
  </div>
  <hr class="hr" />
  <div class="body">
    <div class="label-group">
      <label class="label">EEG-Anlagenschlüssel:</label>
      <label class="sub-label" [innerHTML]="externalProducerId"></label>
    </div>

    <div class="label-group">
      <label class="label">Adresse:</label>
      <label class="sub-label" [innerHTML]="formattedStreetHouse"></label>
      <label class="sub-label" [innerHTML]="formattedZipCode"></label>
    </div>

    <div class="label-group">
      <label class="label">Inbetriebnahmedatum:</label>
      <label class="sub-label" [innerHTML]="formattedInOperationDate"></label>
    </div>

    <div class="label-group">
      <label class="label">Installierte Leistung:</label>
      <label class="sub-label" [innerHTML]="formattedNominalGeneratorPower"></label>
    </div>

    <div class="label-group">
      <label class="label">Netzbetreiber:</label>
      <label class="sub-label" [innerHTML]="dsoIdentifier"></label>
    </div>
  </div>
  <a class="footer" [style.display]="isEnergieMonitorEnabled ? 'block' : 'none'" (click)="openEnergieMonitorV2()">
    <span class="label">Weiterführende Informationen</span>
    <span class="fa fa-play-circle"></span>
  </a>
</div>
